module.exports = __webpack_public_path__ + "market/static/img/scratchcard3.8df120a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/scratchcard3.png
// module id = MgXq
// module chunks = 1